var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkRope(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 315,
    viewBox: "0 0 1440 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3 5H26.5C55.2188 5 78.5 28.2812 78.5 57V271C78.5 291.711 95.2893 308.5 116 308.5V308.5M405.5 308.5H428C456.719 308.5 480 285.219 480 256.5V131V96.75C480 76.1774 463.323 59.5 442.75 59.5H441.25C421.506 59.5 405.5 75.5058 405.5 95.25V95.25C405.5 114.994 421.506 131 441.25 131H581M851 131H859C887.719 131 911 154.281 911 183V257.5C911 286.219 934.281 309.5 963 309.5H976.5C1005.22 309.5 1028.5 286.219 1028.5 257.5V112C1028.5 93.2223 1043.72 78 1062.5 78V78M1278.5 78H1339.5C1368.22 78 1391.5 101.281 1391.5 130V257C1391.5 285.443 1414.56 308.5 1443 308.5V308.5",
    stroke: "#F8F5F5",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkRope);
export default __webpack_public_path__ + "static/media/workRope.9c1c0b01d91a8c89aafc97a17c08a84f.svg";
export { ForwardRef as ReactComponent };